module.exports = __webpack_public_path__ + "img/2-01-07-focus-rd.4cac3565.svg";